import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Passwordless accounts have no password to forget. Signing in with a code
 * already proves the same thing a reset link proves — control of the inbox —
 * so this only ever offered a longer road to the same place, and offered it to
 * people who never had a password at all.
 *
 * /reset-password stays live: links already sitting in inboxes must keep
 * working, and legacy password accounts can still be reset by an admin flow.
 */
export const Route = createFileRoute("/forgot-password")({
  beforeLoad: () => {
    throw redirect({ to: "/sign-in", statusCode: 301 });
  },
});
